/**
 * Diagnostic Discipline Helper
 * Categorizes clinical departments and investigations into:
 * - PATHOLOGY (Laboratory Medicine / In-Vitro Diagnostics)
 * - RADIOLOGY (Diagnostic Imaging / In-Vivo Modalities)
 */

export const DISCIPLINE = {
  PATHOLOGY: 'PATHOLOGY',
  RADIOLOGY: 'RADIOLOGY'
};

const RADIOLOGY_DEPT_KEYWORDS = [
  'X-RAY', 'XRAY', 'ULTRASOUND', 'USG', 'SONOGRAPHY', 
  'CT SCAN', 'CT', 'MRI SCAN', 'MRI', 
  'MAMMOGRAPHY', 'MAMO', 'MAMMO', 
  'DOPPLER', 'DEXA', 'FLUOROSCOPY', 'FLUORO', 
  'INTERVENTIONAL RADIOLOGY', 'IR', 
  'DENTAL', 'OPG', 'ORTHOPANTOMOGRAM',
  'RADIOLOGY', 'IMAGING', 'PET-CT'
];

/**
 * Returns true if department is classified as Radiology
 */
export function isRadiologyDepartment(dept) {
  if (!dept) return false;
  if (dept.categoryId === 2) return true;
  if (dept.categoryId === 1) return false;

  const subCatId = Number(dept.subCategoryId);
  if (subCatId >= 7 && subCatId <= 10) return true;

  const name = (dept.name || dept.departmentName || '').toUpperCase();
  const abbr = (dept.abbreviation || '').toUpperCase();

  return RADIOLOGY_DEPT_KEYWORDS.some(k => name.includes(k) || abbr === k);
}

/**
 * Returns true if investigation is classified as Radiology
 */
export function isRadiologyInvestigation(inv) {
  if (!inv) return false;
  if (inv.reportType === 5) return true;
  if (inv.discipline === 'Radiology' || inv.discipline === 'RADIOLOGY') return true;

  const subCatId = Number(inv.subCategoryId);
  if (subCatId >= 7 && subCatId <= 10) return true;

  const deptName = (inv.departmentName || '').toUpperCase();
  return RADIOLOGY_DEPT_KEYWORDS.some(k => deptName.includes(k));
}

/**
 * Returns 'RADIOLOGY' or 'PATHOLOGY' for an investigation
 */
export function getInvestigationDiscipline(inv) {
  return isRadiologyInvestigation(inv) ? DISCIPLINE.RADIOLOGY : DISCIPLINE.PATHOLOGY;
}

/**
 * Returns 'RADIOLOGY' or 'PATHOLOGY' for a department
 */
export function getDepartmentDiscipline(dept) {
  return isRadiologyDepartment(dept) ? DISCIPLINE.RADIOLOGY : DISCIPLINE.PATHOLOGY;
}

export const ALL_REPORT_TYPES = [
  { value: 1, label: 'Pathology (Numeric / Analyte)', discipline: DISCIPLINE.PATHOLOGY },
  { value: 3, label: 'Pathology (Rich Text / Descriptive)', discipline: DISCIPLINE.PATHOLOGY },
  { value: 5, label: 'Radiology / Diagnostic Imaging', discipline: DISCIPLINE.RADIOLOGY },
  { value: 7, label: 'Histopathology / Biopsy', discipline: DISCIPLINE.PATHOLOGY }
];

export const PATHOLOGY_REPORT_TYPES = ALL_REPORT_TYPES.filter(r => r.discipline === DISCIPLINE.PATHOLOGY);
export const RADIOLOGY_REPORT_TYPES = ALL_REPORT_TYPES.filter(r => r.discipline === DISCIPLINE.RADIOLOGY);
